import { render, staticRenderFns } from "./Upi.vue?vue&type=template&id=817e8c44&scoped=true&"
import script from "./Upi.vue?vue&type=script&lang=js&"
export * from "./Upi.vue?vue&type=script&lang=js&"
import style0 from "./Upi.vue?vue&type=style&index=0&id=817e8c44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817e8c44",
  null
  
)

export default component.exports